import { Form, Validators } from '@angular/forms';
import { FormField } from './form-field.model';

export const RESELLER_FORM: { [key: string]: FormField } = {
	resellerId: {
		id: 'resellerId',
		type: 'hidden',
		name: 'resellerId',
		label: 'ID',
		placeholder: 'ID',
		value: 0,
		data: [],
		validators: [],
		errorMessages: {}
	},
	company: {
		id: 'company',
		type: 'text',
		name: 'company',
		label: 'Azienda',
		placeholder: 'Azienda',
		value: '',
		data: [],
		validators: [Validators.required, Validators.maxLength(50)],
		errorMessages: {
			required: "Inserire il nome dell'azienda.",
			maxlength: "Il nome dell'azienda può contenere al massimo 50 caratteri."
		}
	},
	address: {
		id: 'address',
		type: 'text',
		name: 'address',
		label: 'Indirizzo',
		placeholder: 'Indirizzo',
		value: '',
		data: [],
		validators: [Validators.maxLength(50)],
		errorMessages: {
			maxlength: "L'indirizzo può contenere al massimo 50 caratteri."
		}
	},
	cityId: {
		id: 'cityId',
		type: 'ng-select',
		name: 'cityId',
		label: 'Città',
		placeholder: 'Città',
		value: null,
		data: [],
		validators: [],
		errorMessages: {}
	},
	postalCode: {
		id: 'postalCode',
		type: 'text',
		name: 'postalCode',
		label: 'CAP',
		placeholder: 'CAP',
		value: '',
		data: [],
		validators: [Validators.pattern('^[0-9]{5}$')],
		errorMessages: {
			pattern: 'Il C.A.P. deve essere composto da 5 cifre numeriche.'
		}
	},
	nationId: {
		id: 'nationId',
		type: 'select',
		name: 'nationId',
		label: 'Nazione',
		placeholder: 'Seleziona una nazione',
		value: '',
		data: [],
		validators: [],
		errorMessages: {}
	},
	pIvaTaxId: {
		id: 'pIvaTaxId',
		type: 'text',
		name: 'pIvaTaxId',
		label: 'P.IVA/TAX ID',
		placeholder: 'P.IVA/TAX ID',
		value: '',
		data: [],
		validators: [Validators.pattern('^[0-9]+$'), Validators.maxLength(11)],
		errorMessages: {
			pattern: 'Inserire una P.IVA/TAX ID valida.',
			maxlength: 'La P.IVA/TAX ID può contenere al massimo 11 caratteri.'
		}
	},
	phoneNumber: {
		id: 'phoneNumber',
		type: 'text',
		name: 'phoneNumber',
		label: 'Telefono',
		placeholder: 'Telefono',
		value: '',
		data: [],
		validators: [Validators.maxLength(50)],
		errorMessages: {
			maxlength: 'Il numero di telefono può contenere al massimo 50 caratteri.'
		}
	},
	fax: {
		id: 'fax',
		type: 'text',
		name: 'fax',
		label: 'Fax',
		placeholder: 'Fax',
		value: '',
		data: [],
		validators: [Validators.maxLength(50)],
		errorMessages: {
			maxlength: 'Il fax può contenere al massimo 50 caratteri.'
		}
	},
	url: {
		id: 'url',
		type: 'text',
		name: 'url',
		label: 'URL Rivenditore',
		placeholder: '',
		value: '',
		data: [],
		validators: [
			Validators.maxLength(50),
			Validators.pattern(/^[a-zA-Z0-9-]+$/)
		],
		errorMessages: {
			maxlength: "L'URL può contenere al massimo 50 caratteri.",
			pattern:
				"L'URL può contenere solo lettere, numeri e trattini (senza punti)."
		}
	},
	website: {
		id: 'website',
		type: 'text',
		name: 'website',
		label: 'Sito Rivenditore',
		placeholder: '',
		value: '',
		data: [],
		validators: [
			Validators.pattern(
				'^(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})([/\\w .-]*)*/?$'
			),
			Validators.maxLength(50)
		],
		errorMessages: {
			pattern: 'Inserire un URL valido.',
			maxlength: 'Il sito può contenere al massimo 50 caratteri.'
		}
	},
	email: {
		id: 'email',
		type: 'email',
		name: 'email',
		label: 'Email Rivenditore',
		placeholder: 'info@*****.it',
		value: '',
		data: [],
		validators: [
			Validators.required,
			Validators.email,
			Validators.maxLength(50)
		],
		errorMessages: {
			required: "Inserire l'email del rivenditore.",
			email: "Inserire un'email valida.",
			maxlength: "L'email può contenere al massimo 50 caratteri."
		}
	},
	abbreviation: {
		id: 'abbreviation',
		type: 'text',
		name: 'abbreviation',
		label: 'Abbreviazione',
		placeholder: 'max 2 caratteri',
		value: '',
		data: [],
		validators: [Validators.required, Validators.maxLength(2)],
		errorMessages: {
			required: "Inserire l'abbreviazione del rivenditore.",
			maxlength: "L'abbreviazione deve essere di massimo 2 caratteri."
		}
	},
	isActive: {
		id: 'isActive',
		type: 'select',
		name: 'isActive',
		label: 'Stato',
		placeholder: 'Seleziona uno stato',
		value: false,
		data: [
			{ id: true, name: 'Attivo' },
			{ id: false, name: 'Disattivo' }
		],
		validators: [Validators.required],
		errorMessages: {
			required: 'Selezionare lo stato del rivenditore.'
		}
	},
	isAutomaticRelease: {
		id: 'isAutomaticRelease',
		type: 'select',
		name: 'isAutomaticRelease',
		label: 'Rilascio Attestato',
		placeholder: 'Seleziona un rilascio attestato',
		value: '',
		data: [
			{ id: true, name: 'Automatico' },
			{ id: false, name: 'Manuale' }
		],
		validators: [Validators.required],
		errorMessages: {
			required: 'Selezionare il tipo di rilascio attestato.'
		}
	},
	certifyingAgencyId: {
		id: 'certifyingAgencyId',
		type: 'select',
		name: 'certifyingAgency',
		label: 'Ente Certificatore',
		placeholder: 'Seleziona un ente certificatore',
		value: '',
		data: [],
		validators: [Validators.required],
		errorMessages: {
			required: "Selezionare l'ente certificatore."
		}
	},
	extraNotes: {
		id: 'extraNotes',
		type: 'textarea',
		name: 'extraNotes',
		label: 'Note Extra',
		placeholder:
			'Inserisci delle note extra come ad esempio il metodo di pagamento preferito.',
		value: '',
		data: [],
		validators: [],
		errorMessages: {}
	},
	brandColor: {
		id: 'brandColor',
		type: 'color-picker',
		name: 'brandColor',
		label: 'Colore BRAND',
		placeholder: '#D10000',
		value: '#D10000',
		data: [],
		validators: [Validators.required, Validators.maxLength(50)],
		errorMessages: {
			required: 'Inserire il colore del rivenditore.',
			maxlength: 'Il colore può contenere al massimo 50 caratteri.'
		}
	},
	referentName: {
		id: 'referentName',
		type: 'text',
		name: 'referentName',
		label: 'Nome Referente',
		placeholder: 'Nome',
		value: '',
		data: [],
		validators: [Validators.required, Validators.maxLength(50)],
		errorMessages: {
			required: 'Inserire il nome del referente.',
			maxlength: 'Il nome del referente può contenere al massimo 50 caratteri.'
		}
	},
	referentSurname: {
		id: 'referentSurname',
		type: 'text',
		name: 'referentSurname',
		label: 'Cognome Referente',
		placeholder: 'Cognome',
		value: '',
		data: [],
		validators: [Validators.required, Validators.maxLength(50)],
		errorMessages: {
			required: 'Inserire il cognome del referente.',
			maxlength:
				'Il cognome del referente può contenere al massimo 50 caratteri.'
		}
	},
	referentEmail: {
		id: 'referentEmail',
		type: 'email',
		name: 'referentEmail',
		label: 'Email Referente',
		placeholder: 'Email',
		value: '',
		data: [],
		validators: [
			Validators.required,
			Validators.email,
			Validators.maxLength(50)
		],
		errorMessages: {
			required: "Inserire l'email del referente.",
			email: "Inserire un'email valida.",
			maxlength: "L'email del referente può contenere al massimo 50 caratteri."
		}
	},
	referentFiscalCode: {
		id: 'referentFiscalCode',
		type: 'text',
		name: 'referentFiscalCode',
		label: 'Codice Fiscale',
		placeholder: 'Codice Fiscale',
		value: '',
		data: [],
		validators: [
			Validators.pattern('^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$')
		],
		errorMessages: {
			pattern: 'Inserire un codice fiscale valido.'
		},
		toUppercase: true
	},
	referentBirthDate: {
		id: 'referentBirthDate',
		type: 'date',
		name: 'referentBirthDate',
		label: 'Data di Nascita',
		placeholder: 'Data di nascita',
		value: '',
		data: [],
		validators: [],
		errorMessages: {}
	},
	referentBirthPlaceId: {
		id: 'referentBirthPlaceId',
		type: 'ng-select',
		name: 'referentBirthPlaceId',
		label: 'Luogo di nascita',
		placeholder: 'Luogo di nascita',
		value: null,
		data: [],
		validators: [],
		errorMessages: {}
	},
	referentPostalCode: {
		id: 'referentPostalCode',
		type: 'text',
		name: 'referentPostalCode',
		label: 'CAP Referente',
		placeholder: 'CAP',
		value: '',
		data: [],
		validators: [Validators.pattern('^[0-9]{5}$')],
		errorMessages: {
			pattern: 'Il C.A.P. deve essere composto da 5 cifre numeriche.'
		}
	},
	htmlCode: {
		id: 'htmlCode',
		type: 'textarea',
		name: 'htmlCode',
		label: 'Codice html / CHAT',
		placeholder: 'Inserisci il codice html',
		value: '',
		data: [],
		validators: [],
		errorMessages: {}
	},
	logoDark: {
		id: 'logoDark',
		type: 'text',
		name: 'logoDark',
		label:
			"Puoi allegare il <b>logo dark</b> dell'azienda in formato JPG o PNG, di 147x90 pixel",
		caption: 'Logo dark',
		placeholder: '',
		value: '',
		data: [],
		validators: [Validators.required],
		errorMessages: {
			required: "Inserire l'immagine per il logo dell'azienda."
		}
	},
	logoLight: {
		id: 'logoLight',
		type: 'text',
		name: 'logoLight',
		label:
			"Puoi allegare il <b>logo light</b> dell'azienda in formato JPG o PNG, di 147x90 pixel",
		caption: 'Logo light',
		placeholder: '',
		value: '',
		data: [],
		validators: [],
		errorMessages: {}
	},
	favicon: {
		id: 'favicon',
		type: 'text',
		name: 'favicon',
		label:
			"Puoi allegare il <b>favicon dell'azienda</b> in formato JPG o PNG, di dimensione 147x90 pixel",
		caption: 'Favicon',
		placeholder: '',
		value: '',
		data: [],
		validators: [],
		errorMessages: {}
	},
	logoAzienda: {
		id: 'logoAzienda',
		type: 'text',
		name: 'logoAzienda',
		label:
			"Puoi allegare il <b>logo dell'azienda</b> in formato JPG o PNG, di dimensione 1376x266 pixel",
		caption: "Logo dell'azienda",
		placeholder: '',
		value: '',
		data: [],
		validators: [Validators.required],
		errorMessages: {
			required: "Inserire il logo dell'azienda."
		}
	},
	firmaAttestato: {
		id: 'firmaAttestato',
		type: 'text',
		name: 'firmaAttestato',
		label:
			"Puoi allegare <b>l'immagine della firma dell'attestato</b> in formato JPG o PNG, di dimensione 683x173 pixel",
		caption: "Immagine della firma dell'attestato",
		placeholder: '',
		value: '',
		data: [],
		validators: [Validators.required],
		errorMessages: {
			required: "Inserire l'immagine della firma dell'attestato."
		}
	},
	imgFooter: {
		id: 'imgFooter',
		type: 'text',
		name: 'imgFooter',
		label:
			"Puoi allegare <b>l'immagine per il footer</b> del rivenditore in formato JPG o PNG, di dimensione 1355x156 pixel",
		caption: 'Immagine per il footer',
		placeholder: '',
		value: '',
		data: [],
		validators: [Validators.required],
		errorMessages: {
			required: "Inserire l'immagine per il footer del rivenditore."
		}
	}
};
